import { zodResolver } from '@hookform/resolvers/zod'
import { Grid } from '@mui/joy'
import { useStore } from 'effector-react'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  aggregatorDriverSchema,
  FormValues,
} from '~/entities/common/Driver/Aggregator/aggregatorDriverModel'
import {
  TextInput,
  FormButtons,
  formButtonsModel,
  FormProvider,
  NumericInput,
  Switch,
} from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type FormProps = {
  canEdit?: boolean
  isSubmitting?: boolean
  isLoading?: boolean
  onSuccess?: (formValues: FormValues) => void
  defaultValues?: Partial<FormValues>
  accountId?: UniqueId
}

export function YandexForm({
  canEdit,
  isSubmitting,
  isLoading,
  defaultValues,
  onSuccess,
}: FormProps) {
  const { t } = useTranslation()

  const isEditing = useStore(formButtonsModel.$isEditing)
  const disabled = !isEditing || isSubmitting

  const form = useForm<FormValues>({
    resolver: zodResolver(aggregatorDriverSchema),
    defaultValues,
  })

  useEffect(() => {
    if (defaultValues) form.reset(defaultValues)
    // eslint-disable-next-line
  }, [defaultValues, isEditing])

  return (
    <FormProvider form={form} onSuccess={onSuccess} canEdit={canEdit}>
      <Container>
        <ContainerTitle>{t('information')}</ContainerTitle>
        <Grid container spacing={2.5} alignItems='flex-start'>
          <Grid xs={4}>
            <Switch
              labelI18n='form.disable orders when balance is below the limit'
              name='blockOrdersOnBalanceBelowLimit'
              skeletonShow={isLoading}
              readOnly={disabled}
            />
          </Grid>
          <Grid xs={4}>
            <Switch
              labelI18n='form.are orders from partner allowed'
              name='partner'
              skeletonShow={isLoading}
              readOnly={disabled}
            />
          </Grid>
          <Grid xs={4}>
            <Switch
              labelI18n='form.are orders from platform allowed'
              name='platform'
              skeletonShow={isLoading}
              readOnly={disabled}
            />
          </Grid>
          <Grid xs={6}>
            <TextInput
              label='form.working conditions'
              name='yandexWorkRule'
              skeletonShow={isLoading}
              readOnly
            />
          </Grid>
          <Grid xs={6}>
            <TextInput
              label='form.employment type'
              name='aggregatorOccupation'
              skeletonShow={isLoading}
              readOnly
            />
          </Grid>

          <Grid xs={12}>
            <NumericInput
              label='form.account balance limit'
              name='balanceLimit'
              skeletonShow={isLoading}
              readOnly
            />
          </Grid>
        </Grid>
      </Container>
      <FormButtons loading={isSubmitting} />
    </FormProvider>
  )
}
